"use client";

/**
 * Les deux boutons des pages du live, et le pictogramme du récital.
 *
 * Ils vivaient dans la modale d'ouverture de séance, parce qu'elle les avait
 * vus naître. La séance a quitté l'interface ; les boutons restent, et
 * l'accueil, les sections et l'état creux doivent garder le même dessin au
 * pixel près. Un fichier à eux plutôt qu'une copie dans chaque page : deux
 * copies, ce sont deux rayons d'arrondi qui divergent.
 */

const BUTTON_BASE =
  "inline-flex items-center gap-2 h-9 px-4 rounded-[10px] text-[13px] font-medium whitespace-nowrap cursor-pointer transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent disabled:cursor-default disabled:opacity-60";

export function PrimaryButton({
  onClick,
  disabled = false,
  children,
}: {
  onClick: () => void;
  disabled?: boolean;
  children: React.ReactNode;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`${BUTTON_BASE} bg-accent text-white hover:bg-accent-bright`}
    >
      {children}
    </button>
  );
}

export function GhostButton({
  onClick,
  children,
}: {
  onClick: () => void;
  children: React.ReactNode;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`${BUTTON_BASE} border border-border-strong text-text-secondary hover:text-text-primary hover:bg-white/[0.04]`}
    >
      {children}
    </button>
  );
}

/** Une page de calendrier : « c'est pour plus tard ». */
export function CalendarIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      aria-hidden="true"
    >
      <rect x="2" y="3" width="10" height="9" rx="1.5" />
      <path d="M2 6h10M5 1.5v3M9 1.5v3" />
    </svg>
  );
}

/** Un globe : visible de tous. */
export function GlobeIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      aria-hidden="true"
    >
      <circle cx="7" cy="7" r="5.2" />
      <path d="M1.8 7h10.4M7 1.8c2 2 2 8.4 0 10.4M7 1.8c-2 2-2 8.4 0 10.4" />
    </svg>
  );
}

/** Un cadenas : seulement avec le lien ou le code. */
export function LockIcon({ size = 14 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      aria-hidden="true"
    >
      <rect x="2.5" y="6" width="9" height="6" rx="1.2" />
      <path d="M4.5 6V4.5a2.5 2.5 0 0 1 5 0V6" />
    </svg>
  );
}
